module.exports = __webpack_public_path__ + "static/media/friends.218e6956.svg";